module.exports = __webpack_public_path__ + "static/media/3.c0d6d5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/3.png
// module id = 492
// module chunks = 0